import type { ReactElement } from "react";
import { MilestonePanel } from "../../../views/milestones/MilestonePanel.js";
import type { InhaltProps } from "../ObjektPanelGastgeber.js";

/**
 * DER MEILENSTEIN IM OBJEKTPANEL (Spec F6, C3; PF8): das `MilestonePanel` mit `verlauf`. Im Gastgeber steht er immer seitlich —
 * er kommt nur aus dem Reiter „Verknüpfungen“ eines Ticketpanels. Der Panelknopf einer Ticketzeile ersetzt ihn durch das Ticket
 * (`onWechsel`, F5): Das Panel hat dann schon gefragt, die Ebene meldet deshalb nichts Ungespeichertes mehr; hatte es
 * geschrieben, erfährt es die Stelle darunter wie beim Schließen (F9).
 */
export function MeilensteinInhalt(p: InhaltProps<"meilenstein">): ReactElement {
  return (
    <MilestonePanel client={p.client} companies={p.companies} milestoneId={p.bezug.id} defaultCompanyId={p.bezug.companyId}
      verlauf {...(p.seitlich ? { unter: "seitlich" as const } : {})} onUngespeichert={p.onUngespeichert}
      onClose={(changed) => { if (changed) p.onGeaendert(); p.onSchliessen(); }}
      onOpenTicket={(id, changed) => {
        if (changed) p.onGeaendert();
        p.onUngespeichert(false);
        p.onWechsel({ art: "ticket", id });
      }} />
  );
}
